// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gZwhQ","comment":"styles_comment__3pCmY"};